/** Имя CustomEvent для открытия модалки установки PWA */
export const OPEN_PWA_INSTALL_GUIDE_EVENT = 'admin-open-pwa-guide'

/**
 * Открывает модалку с инструкцией установки (слушатель в InstallPwaGuideHost).
 */
export const openPwaInstallGuide = (): void => {
  if (typeof window === 'undefined') {
    return
  }
  window.dispatchEvent(new CustomEvent(OPEN_PWA_INSTALL_GUIDE_EVENT))
}
